import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Biology } from 'src/app/entities/biology.entity/biology';

@Component({
  selector: 'app-biology-form',
  templateUrl: './biology-form.component.html',
  styleUrls: ['./biology-form.component.css'],
})
export class BiologyFormComponent implements OnInit {
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    // height: '60rem',
    minHeight: '0',
    maxHeight: 'auto',
    // width: '62rem',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,

    showToolbar: true,
    placeholder: '',
    defaultParagraphSeparator: '',

    defaultFontName: '',
    defaultFontSize: '',

    /* customClasses: [{
      name: 'table',
      class: '<!--',
      tag: 'table class="table table-bordered"><tr><td>&nbsp;</td><td>&nbsp;</td></tr><tr><td>&nbsp;</td><td>&nbsp;</td></tr></table> <!-- '
  }],*/
    sanitize: false,
  };

  @Input() biology: Biology = new Biology();
  @Output() biologyChanged: EventEmitter<Biology> = new EventEmitter();
  @Input() isSubmitted: boolean = false;

  constructor() {}

  ngOnInit(): void {}
  get isValid(): boolean {
    return this.biology.element_Bio.length > 0;
  }
  _change(): void {
    this.biologyChanged.emit(this.biology);
  }
}
